import React from 'react';
import { connect } from 'react-redux'

import { removeNotification } from 'actioncreators/notification';

export const Notification = ({ data, onClick }) => {
	let extraClass = ' notification-';
	if (data.type) {
		extraClass += data.type;
	} else {
		extraClass += 'primary';
	}
	return (
		<div className={"notification" + extraClass}>
			<span className="notification-close" onClick={(e) => {
				onClick(data.id);
			}}>&times;</span>
			{data.data}
		</div>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		onClick: (id) => {
			dispatch(removeNotification(id));
		}
	}
};

const NotificationContainer = connect((state) => ({}), mapDispatchToProps)(Notification)

export default NotificationContainer;



/** WEBPACK FOOTER **
 ** ./components/notification/notification.js
 **/